import algoliasearch from "algoliasearch/lite";
import { InstantSearch } from "react-instantsearch/dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
/* page components */
// import About from "./components/about/About";
import LoadedResults from "./components/infiniteHits/LoadedResults";
import NavBar from "./components/navbar/NavBar";
import SearchBar from "./components/searchbar/SearchBar";
// import Login from "./components/loginSignUp/Login";
// import SignUp from "./components/loginSignUp/Signup";
import TempHome from "./components/tempSplash";


/* CSS Files */
import "./css/normalize.css";
import "./css/the-brain.webflow.css";
import "./css/webflow.css";
import NotFound from "./components/NotFound";
// import Pricing from "./components/pricing";


function App() {
	const algolia_id = process.env.REACT_APP_ALGOLIA_APP_ID;
	const algolia_key = process.env.REACT_APP_ALGOLIA_SEARCH_KEY;

	const searchClient = algoliasearch(algolia_id, algolia_key);
	return (
		<Router>
			<header>
				<NavBar />
			</header>

			<Switch id="test" >
				<Route exact path="/" component={TempHome} />
{/* 
				<Route path="/about" component={About} />
				<Route path="/pricing" component={Pricing} /> */}

				<Route path="/brain">
					<InstantSearch searchClient={searchClient} indexName="d_brain">
						<SearchBar />
						<LoadedResults />
					</InstantSearch>
				</Route>
{/* 
				<Route path="/login" render={(props) => <Login {...props}/>} />
				<Route path="/signup" render={(props) => <SignUp {...props}/>} /> */}

				<Route component={NotFound} />
			</Switch>
		</Router>
	);
}

export default App;
